export default {
    methods: {
        formatRowByFieldConfig() {
            if (this.fields !== undefined && this.rowList.length > 0) {
                for (let temp of this.fields) {
                    if (temp.hasOwnProperty('defaultValue')) {
                        this.initDefaultValue(temp);
                    }
                    if (temp.format === 'number') {
                        this.formatNumber(temp);
                    }
                }
            }
        },
        initDefaultValue(field) {
            for (let row of this.rowList) {
                let originValue = row[field.key];
                if (originValue !== undefined && originValue != null) {
                    continue;
                }
                let defaultValue = field.defaultValue;
                if (defaultValue instanceof Function) {
                    defaultValue = defaultValue(row);
                }
                this.$set(row, field.key, defaultValue);
            }
        },

        formatNumber({key}) {
            for (let row of this.rowList) {
                let originValue = row[key];
                if (originValue) {
                    this.$set(row, key, Number.parseFloat(originValue));
                }
            }
        },
    }
}
